export default __webpack_public_path__ + "static/media/MuteCh1Off.39cdab96.svg";